module.exports = {"name":"html5","type":"adapter","tech":"js","author":"Jordi Aguilar","version":"6.0.2","built":"2017-07-27","repo":"https://bitbucket.org/npaw/html5-adapter-js.git","libVersion":"6.0.3","features":{"buffer":"monitor","seek":"native","getters":["getPlayhead","getDuration","getResource"]},"ads":[]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 25
// module chunks = 0